import React from 'react';
import { Link } from 'react-router-dom';

// Build the demo subdomain URL. Browsers don't reliably resolve
// *.localhost or IP-based subdomains, so for dev we swap localhost/IP
// for lvh.me (which has wildcard DNS to 127.0.0.1). In prod the host
// is already serbia-shop.com so we just prefix the slug.
const demoBaseUrl = () => {
  const { protocol, hostname, port } = window.location;
  const isLocal = hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname);
  const host = isLocal ? 'lvh.me' : hostname;
  const suffix = port ? `:${port}` : '';
  return `${protocol}//demo.${host}${suffix}`;
};

const DEMO_EMAIL = 'demo@shop.com';
const DEMO_PASSWORD = 'demo1234';

const Landing: React.FC = () => (
  <div style={page}>
    <div style={container}>
      <div style={{ fontSize: 13, color: '#fbbf24', fontWeight: 600, letterSpacing: 1, marginBottom: 12 }}>
        ★ SERBIA SHOP
      </div>
      <h1 style={hero}>
        Vaša online prodavnica<br />za nekoliko minuta.
      </h1>
      <p style={subtitle}>
        Registrujte se, dobijte svoj subdomen (npr. <code style={code}>vasa-prodavnica.serbia-shop.com</code>)
        i krenite da prodajete. Bez tehničkog znanja, bez instalacije.
      </p>

      <div style={ctaRow}>
        <Link to="/register" style={primary}>
          Registruj prodavnicu →
        </Link>
        <a href={demoBaseUrl()} style={demo} target="_blank" rel="noopener noreferrer">
          Pogledaj demo
        </a>
        <a href={`${demoBaseUrl()}/admin`} style={demo} target="_blank" rel="noopener noreferrer">
          Otvori admin
        </a>
        <Link to="/login" style={secondary}>
          Imaš nalog? Prijavi se
        </Link>
      </div>

      <div style={credBox}>
        <div style={credTitle}>Demo admin pristup</div>
        <div style={credRow}>
          <span style={credLabel}>email:</span>
          <code style={credValue}>{DEMO_EMAIL}</code>
        </div>
        <div style={credRow}>
          <span style={credLabel}>šifra:</span>
          <code style={credValue}>{DEMO_PASSWORD}</code>
        </div>
      </div>

      <div style={features}>
        <Feature title="Sopstveni subdomen" text="Svaka prodavnica dobija svoj subdomen na serbia-shop.com" />
        <Feature title="Bez koda" text="Sve podešavanja kroz admin panel — proizvodi, kategorije, plaćanja" />
        <Feature title="Bezbedno" text="Vaši podaci su izolovani od ostalih prodavnica" />
      </div>
    </div>
  </div>
);

const Feature: React.FC<{ title: string; text: string }> = ({ title, text }) => (
  <div style={{ flex: 1, minWidth: 200 }}>
    <div style={{ color: '#fbbf24', fontWeight: 600, marginBottom: 6 }}>{title}</div>
    <div style={{ color: '#94a3b8', fontSize: 14, lineHeight: 1.5 }}>{text}</div>
  </div>
);

const page: React.CSSProperties = {
  minHeight: '100vh',
  background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
  color: '#e2e8f0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 40,
};

const container: React.CSSProperties = {
  maxWidth: 880,
  width: '100%',
  textAlign: 'center',
};

const hero: React.CSSProperties = {
  fontSize: 56,
  fontWeight: 700,
  lineHeight: 1.1,
  margin: '0 0 24px',
  color: '#fff',
};

const subtitle: React.CSSProperties = {
  fontSize: 18,
  color: '#cbd5e1',
  lineHeight: 1.6,
  marginBottom: 40,
};

const code: React.CSSProperties = {
  background: '#1e293b',
  padding: '2px 8px',
  borderRadius: 4,
  color: '#fbbf24',
  fontSize: 15,
};

const ctaRow: React.CSSProperties = {
  display: 'flex',
  gap: 16,
  justifyContent: 'center',
  flexWrap: 'wrap',
  marginBottom: 64,
};

const primary: React.CSSProperties = {
  background: '#fbbf24',
  color: '#0f172a',
  padding: '14px 28px',
  borderRadius: 6,
  textDecoration: 'none',
  fontWeight: 600,
  fontSize: 16,
};

const secondary: React.CSSProperties = {
  background: 'transparent',
  color: '#e2e8f0',
  padding: '14px 28px',
  borderRadius: 6,
  textDecoration: 'none',
  fontWeight: 500,
  fontSize: 16,
  border: '1px solid #475569',
};

const demo: React.CSSProperties = {
  background: '#1e293b',
  color: '#fbbf24',
  padding: '14px 28px',
  borderRadius: 6,
  textDecoration: 'none',
  fontWeight: 600,
  fontSize: 16,
  border: '1px solid #fbbf24',
};

const credBox: React.CSSProperties = {
  display: 'inline-block',
  textAlign: 'left',
  background: 'rgba(251, 191, 36, 0.08)',
  border: '1px dashed rgba(251, 191, 36, 0.45)',
  borderRadius: 8,
  padding: '14px 22px',
  marginTop: -40,
  marginBottom: 56,
};

const credTitle: React.CSSProperties = {
  color: '#fbbf24',
  fontSize: 13,
  fontWeight: 600,
  letterSpacing: 0.5,
  textTransform: 'uppercase',
  marginBottom: 8,
};

const credRow: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  fontSize: 14,
  color: '#cbd5e1',
  margin: '3px 0',
};

const credLabel: React.CSSProperties = {
  minWidth: 56,
  color: '#94a3b8',
};

const credValue: React.CSSProperties = {
  background: '#0f172a',
  padding: '3px 10px',
  borderRadius: 4,
  color: '#fbbf24',
  fontFamily: 'monospace',
  fontSize: 14,
  userSelect: 'all',
};

const features: React.CSSProperties = {
  display: 'flex',
  gap: 32,
  justifyContent: 'center',
  flexWrap: 'wrap',
  textAlign: 'left',
  marginTop: 32,
};

export default Landing;
